window.TOOLS_DATA = {
 "cards": [
  {
   "id": "universal40",
   "badge": "80-IN-1 · TSA-SAFE",
   "name": "Universal 4.0",
   "img": "https://mrf.tools/cdn/shop/files/NVV02531-1.jpg?v=1718352146&width=1200",
   "url": "/products/universal-4-0-titanium",
   "price": "from $38",
   "spec": "85 × 54 MM · TI GR5 28 G / 440C",
   "tools": [
    {
     "n": 1,
     "x": 24,
     "y": 34,
     "cat": "DRIVE",
     "name": "1/4\" bit driver with lock",
     "desc": "Universal holder for standard 1/4\", 4 mm and Leatherman flat bits. The lock keeps the bit seated so it doesn't wobble under torque.",
     "sc": "Assembling flat-pack furniture at a friend's place — grab any bit from a drawer, click it in, done."
    },
    {
     "n": 2,
     "x": 38,
     "y": 16,
     "cat": "WRENCH",
     "name": "Metric wrench set M3–M17",
     "desc": "Open wrench cutouts covering the metric range you meet on bikes, drones and household hardware.",
     "sc": "A loose M6 nut on your bike rack, 40 km from home. Card out of wallet, snug it down, ride on."
    },
    {
     "n": 3,
     "x": 49,
     "y": 25,
     "cat": "WRENCH",
     "name": "Imperial wrenches 5/16\"–9/16\"",
     "desc": "Full imperial open-wrench set alongside the metric one — no adapter, no guessing.",
     "sc": "US-spec hardware on a rented cabin's gas valve — the 1/2\" cutout fits where your fingers can't."
    },
    {
     "n": 4,
     "x": 7,
     "y": 42,
     "cat": "NAVIGATE",
     "name": "Sundial & compass",
     "desc": "Battery-free time and direction, engraved for both Northern and Southern hemispheres.",
     "sc": "Phone died on a day hike. Level the card, align the shadow — you have time and rough bearing."
    },
    {
     "n": 5,
     "x": 10,
     "y": 21,
     "cat": "NAVIGATE",
     "name": "Moon phase calendar",
     "desc": "Engraved lunar calendar to read the current and coming moon phases.",
     "sc": "Planning a night fishing trip — check when the moon gives you light and active fish."
    },
    {
     "n": 6,
     "x": 19,
     "y": 44,
     "cat": "BIKE",
     "name": "Spoke wrenches",
     "desc": "13ga, 14ga, 15ga and 4.3 mm spoke keys machined into the edge.",
     "sc": "A wobbling wheel mid-tour: true it by the trail instead of walking to the next town."
    },
    {
     "n": 7,
     "x": 13,
     "y": 30,
     "cat": "MEASURE",
     "name": "Ruler & protractor",
     "desc": "Metric + imperial scales and a precision protractor readable to 1/3°.",
     "sc": "Marking a shelf bracket angle at the in-laws' — no toolbox required, it's in your wallet."
    },
    {
     "n": 8,
     "x": 30,
     "y": 49,
     "cat": "MODULAR",
     "name": "Tool KIT slot",
     "desc": "The modular slot takes snap-in KITs — saw, file, scissors, comb — shared across Universal 3.0 / 4.0 / 5.0.",
     "sc": "Swap in the saw KIT before a camping weekend, the comb KIT before a business trip."
    },
    {
     "n": 9,
     "x": 33,
     "y": 27,
     "cat": "OPEN",
     "name": "Bottle & can opener",
     "desc": "Classic cap lifter plus a can-opening edge — the most-used cutouts on any card.",
     "sc": "Friday, lake, no opener in sight. There is now."
    },
    {
     "n": 10,
     "x": 55,
     "y": 62,
     "cat": "TRAVEL",
     "name": "TSA-removable insert",
     "desc": "The one sharp element pops out, leaving an 80-function card that flies in hand luggage.",
     "sc": "Before airport security: pop the insert into checked baggage, keep the card in your wallet."
    }
   ]
  },
  {
   "id": "universal30",
   "badge": "60-IN-1 · FULL MAP",
   "name": "Universal 3.0",
   "img": "https://mrf.tools/cdn/shop/files/mrf26-u3-explorer.png?v=b3",
   "url": "/products/universal-3-0-titanium",
   "price": "from $32",
   "spec": "85 × 55 × 2 MM · TI GR5 22 G / 440C 38 G",
   "tools": [
    {
     "n": 1,
     "x": 12.5,
     "y": 6.1,
     "cat": "BIKE",
     "name": "14ga spoke wrench",
     "desc": "Spoke key for 14-gauge spokes, machined into the top notch.",
     "sc": "True a commuter wheel at the bike rack before it rubs the brake pad."
    },
    {
     "n": 2,
     "x": 16.5,
     "y": 13,
     "cat": "GRILL",
     "name": "BBQ grill scraper",
     "desc": "Zig-zag edge that follows round grill bars and scrapes them clean.",
     "sc": "Someone else's crusty campsite grate, sorted before the steaks go on."
    },
    {
     "n": 3,
     "x": 21,
     "y": 16.3,
     "cat": "BIKE",
     "name": "13ga & 15ga spoke wrench",
     "desc": "Two more spoke gauges, covering older and heavy-duty wheels.",
     "sc": "Cargo-bike spokes are 13ga — this is the key that fits them."
    },
    {
     "n": 4,
     "x": 17.5,
     "y": 19.5,
     "cat": "WRENCH",
     "name": "11/16\", 10/16\", 9/16\" wrench",
     "desc": "Imperial open-wrench cutouts along the diagonal spine.",
     "sc": "US-spec camp stove fitting — 9/16\" where no wrench set exists."
    },
    {
     "n": 5,
     "x": 33,
     "y": 20,
     "cat": "WRENCH",
     "name": "15 mm, 13 mm wrench",
     "desc": "The two most common big metric nuts on bikes and furniture.",
     "sc": "15 mm is every bike axle nut ever. It's on the card."
    },
    {
     "n": 6,
     "x": 9,
     "y": 26,
     "cat": "DRIVE",
     "name": "Flat screwdriver",
     "desc": "Reinforced flat-blade tip on the card edge with real torque.",
     "sc": "Tighten a sagging door hinge on the way out of the house."
    },
    {
     "n": 7,
     "x": 26,
     "y": 43,
     "cat": "CUT",
     "name": "Cord cutter",
     "desc": "Recessed slot that cuts cord and zip-ties with no exposed blade.",
     "sc": "Zip-tied packaging in the parking lot — cut without a knife."
    },
    {
     "n": 8,
     "x": 13,
     "y": 38,
     "cat": "OPEN",
     "name": "Can opener",
     "desc": "Classic lever-style can edge, sharpened where it bites the lid.",
     "sc": "Beans at camp. The one tool everyone forgets, in your wallet."
    },
    {
     "n": 9,
     "x": 33.8,
     "y": 43.8,
     "cat": "FIRE",
     "name": "Firestarter",
     "desc": "Hardened scraper spots that throw sparks off a ferro rod.",
     "sc": "Lighter soaked in a river crossing; the ferro rod still works."
    },
    {
     "n": 10,
     "x": 30.5,
     "y": 47,
     "cat": "FILE",
     "name": "Rasp & nail file",
     "desc": "Wavy filing edge — 6 and 8 mm pitch — for wood, plastic and nails.",
     "sc": "Smooth a splintered tent-pole end before it shreds the sleeve."
    },
    {
     "n": 11,
     "x": 48,
     "y": 55,
     "cat": "MEASURE",
     "name": "Metric ruler 0–60 mm",
     "desc": "Engraved millimetre scale along side B's top edge.",
     "sc": "Measure a bolt before the hardware store, not after."
    },
    {
     "n": 12,
     "x": 13.5,
     "y": 71,
     "cat": "WRENCH",
     "name": "5/16\"–1/2\" + 10, 12 mm wrench",
     "desc": "Mixed metric/imperial set covering the mid range in one row.",
     "sc": "Drone prop nuts, shelf bolts, hose fittings — one cutout row."
    },
    {
     "n": 13,
     "x": 30,
     "y": 73.5,
     "cat": "WIRE",
     "name": "Wire bender",
     "desc": "Graduated holes for bending wire and spokes to a clean radius.",
     "sc": "Form a spare hook for hanging a lantern in the tent."
    },
    {
     "n": 14,
     "x": 17,
     "y": 88.5,
     "cat": "NAVIGATE",
     "name": "Sundial clock",
     "desc": "Radial dial that reads time from a shadow — no battery.",
     "sc": "Phone at 0%. Level the card, read the shadow: ~4 pm, head back."
    },
    {
     "n": 15,
     "x": 12.5,
     "y": 62.5,
     "cat": "NAVIGATE",
     "name": "Sundial compass",
     "desc": "North/South hemisphere scales for rough bearing from the sun.",
     "sc": "Cloudless sky and no signal — orient the map the old way."
    },
    {
     "n": 16,
     "x": 27,
     "y": 91.5,
     "cat": "MEASURE",
     "name": "Metric & inch compass",
     "desc": "Pivot hole plus pen holes to sweep exact circles in mm or inches.",
     "sc": "Draw a clean Ø50 circle for a speaker cutout template."
    },
    {
     "n": 17,
     "x": 6.5,
     "y": 95,
     "cat": "MEASURE",
     "name": "L square",
     "desc": "The card's corner is a true 90° square with dual scales.",
     "sc": "Check a picture frame is actually square before gluing it."
    },
    {
     "n": 18,
     "x": 38.7,
     "y": 4.8,
     "cat": "MEASURE",
     "name": "Inch ruler 0–2\"",
     "desc": "Imperial scale along side A's top edge, 1/16\" graduations.",
     "sc": "Reading plans in inches on a metric card — no conversion."
    },
    {
     "n": 19,
     "x": 78,
     "y": 6.5,
     "cat": "PRY",
     "name": "Nail puller",
     "desc": "Tapered claw slot that grips nail heads for levering out.",
     "sc": "Pull the staples-and-nails mess off a pallet for a weekend project."
    },
    {
     "n": 20,
     "x": 93.5,
     "y": 10,
     "cat": "PRY",
     "name": "Pry bar",
     "desc": "Reinforced edge corner for prying lids and seams — save your fingernails.",
     "sc": "Paint tin lid, phone-free: pry, stir, done."
    },
    {
     "n": 21,
     "x": 94.5,
     "y": 14.5,
     "cat": "SURVIVAL",
     "name": "Survival axe",
     "desc": "Mounts to a stick to become a compact chopping edge.",
     "sc": "Split kindling at camp with a lashed-on handle."
    },
    {
     "n": 22,
     "x": 95,
     "y": 20,
     "cat": "SURVIVAL",
     "name": "Shovel",
     "desc": "Scoop profile — lash it to a handle for digging duty.",
     "sc": "Dig a drainage trench around the tent in a downpour."
    },
    {
     "n": 23,
     "x": 94.5,
     "y": 25,
     "cat": "SURVIVAL",
     "name": "Scraper",
     "desc": "Broad flat edge for scraping hide, bark, ice or paint.",
     "sc": "Frosted windshield, scraper in the wallet. Morning saved."
    },
    {
     "n": 24,
     "x": 73,
     "y": 25.5,
     "cat": "MEASURE",
     "name": "Protractor 0–90°",
     "desc": "Engraved quarter-circle protractor readable to fine degrees.",
     "sc": "Set the mitre saw by the card when the gauge is off."
    },
    {
     "n": 25,
     "x": 78,
     "y": 34.5,
     "cat": "WRENCH",
     "name": "Oxygen wrench",
     "desc": "Square cutout that fits standard gas-bottle valve keys.",
     "sc": "Open a welding or O₂ bottle when the key walked off."
    },
    {
     "n": 26,
     "x": 83,
     "y": 30.5,
     "cat": "GAUGE",
     "name": "Sheet thickness gauge",
     "desc": "6–7 mm slots plus steps that size sheet stock instantly.",
     "sc": "Which ply is this? Slide the edge on, read it off."
    },
    {
     "n": 27,
     "x": 85.5,
     "y": 39.5,
     "cat": "OPEN",
     "name": "Box opener",
     "desc": "Hooked tape-cutting edge — opens cartons, spares the contents.",
     "sc": "Daily parcels opened without stabbing what's inside."
    },
    {
     "n": 28,
     "x": 52,
     "y": 46,
     "cat": "CUT",
     "name": "Knife",
     "desc": "Sharpened section of the bottom edge for real cutting jobs.",
     "sc": "Cheese, cord and cardboard at a roadside picnic."
    },
    {
     "n": 29,
     "x": 80,
     "y": 58.7,
     "cat": "DRIVE",
     "name": "1/4\" & 1/8\" bit driver",
     "desc": "Square sockets that hold standard screwdriver bits.",
     "sc": "Any bit from the drawer becomes a wallet screwdriver."
    },
    {
     "n": 30,
     "x": 75.5,
     "y": 66.8,
     "cat": "WRENCH",
     "name": "3/16\" wrench",
     "desc": "Small imperial cutout for electronics and skate hardware.",
     "sc": "Skateboard axle nuts at the park, no tool bag."
    },
    {
     "n": 31,
     "x": 84,
     "y": 64.3,
     "cat": "WRENCH",
     "name": "Butterfly wrench",
     "desc": "Winged cutout that grips wing nuts and thumbscrews.",
     "sc": "Seized wing nut on a garden hose reel — leverage, not fingers."
    },
    {
     "n": 32,
     "x": 93,
     "y": 63.3,
     "cat": "OPEN",
     "name": "Bottle opener",
     "desc": "The most-used cutout on any card, tuned to lift caps first try.",
     "sc": "Friday, lake, capped bottles. You're the hero again."
    },
    {
     "n": 33,
     "x": 69,
     "y": 74.5,
     "cat": "MEASURE",
     "name": "Quick angle",
     "desc": "Preset angle edges for marking common cuts fast.",
     "sc": "Mark 45° on trim without unpacking the mitre box."
    },
    {
     "n": 34,
     "x": 52,
     "y": 68,
     "cat": "NAVIGATE",
     "name": "Distance ruler",
     "desc": "Map-range scale — sight a known-height object, read distance.",
     "sc": "Estimate how far the far shore is before committing to the paddle."
    },
    {
     "n": 35,
     "x": 77.5,
     "y": 78.5,
     "cat": "WIRE",
     "name": "Wire stripper",
     "desc": "Sized notches that strip insulation without nicking the core.",
     "sc": "Splice a trailer-light wire in a fuel-station car park."
    },
    {
     "n": 36,
     "x": 28,
     "y": 68.5,
     "cat": "GAUGE",
     "name": "Drill gauge Ø1.2–2.5",
     "desc": "Ø-marked holes that identify small drill bits and wire.",
     "sc": "Unmarked bits from the jar, identified in seconds."
    },
    {
     "n": 37,
     "x": 82.5,
     "y": 90.3,
     "cat": "WRENCH",
     "name": "4, 5, 5.5 mm wrench",
     "desc": "The small-metric trio for electronics and bike fittings.",
     "sc": "Tighten a 5 mm standoff on a 3D-printer frame mid-print."
    },
    {
     "n": 38,
     "x": 91.5,
     "y": 96,
     "cat": "GAUGE",
     "name": "Tyre depth gauge",
     "desc": "Stepped corner that reads tread depth against the legal limit.",
     "sc": "Check the tread before winter — sell the excuse, not the car."
    }
   ]
  },
  {
   "id": "extreme",
   "badge": "50-IN-1 · TORQUE HANDLE",
   "name": "Extreme",
   "img": "https://mrf.tools/cdn/shop/files/NVV089716.jpg?v=1717921541&width=1200",
   "url": "/products/extreme-3-0-preorder",
   "price": "from $43",
   "spec": "85 × 55 × 3 MM · TI 30 G / STEEL 50 G",
   "tools": [
    {
     "n": 1,
     "x": 28,
     "y": 21,
     "cat": "TORQUE",
     "name": "Handle connecting pins",
     "desc": "The modular torque handle clicks straight into these pins — no screws — turning the card into a real lever.",
     "sc": "A seized pedal bolt: click the handle in and put your body weight on it, not your fingertips."
    },
    {
     "n": 2,
     "x": 56,
     "y": 27,
     "cat": "TORQUE",
     "name": "Nut & bolt slots",
     "desc": "The only card tool on the market with dedicated slots that seat nuts and bolts for turning in tight spots.",
     "sc": "A nut behind a radiator pipe where no wrench fits flat — the card does."
    },
    {
     "n": 3,
     "x": 80,
     "y": 77,
     "cat": "DRIVE",
     "name": "1/4\" bit clip with lock",
     "desc": "Locks any standard hex bit in place for stable, no-slip screwdriving. Pairs with the Bit Store Card.",
     "sc": "Tightening binding screws on a snowboard in the parking lot before first lift."
    },
    {
     "n": 4,
     "x": 20,
     "y": 51,
     "cat": "WRENCH",
     "name": "Metric wrenches 6–17 mm",
     "desc": "Full metric open-wrench set machined through the card body.",
     "sc": "Trailside derailleur adjustment: 8, 9, 10 mm right where you need them."
    },
    {
     "n": 5,
     "x": 86,
     "y": 41,
     "cat": "WRENCH",
     "name": "Imperial set 5/16\"–9/16\"",
     "desc": "The imperial range for US-spec bikes, skate hardware and camp gear.",
     "sc": "Skatepark truck adjustment with the 9/16\" cutout — no tool bag."
    },
    {
     "n": 6,
     "x": 48,
     "y": 90,
     "cat": "BIKE",
     "name": "Spoke wrenches",
     "desc": "13ga, 14ga, 15ga + 4.3 mm keys, plus wire-bending holes.",
     "sc": "True a wheel on tour; bend a spare spoke end to hold gear together till camp."
    },
    {
     "n": 7,
     "x": 70,
     "y": 62,
     "cat": "CUT",
     "name": "Cord cutter (no blade)",
     "desc": "A recessed edge slices rope, cord and zip-ties with no exposed blade — the reason Extreme is TSA-safe.",
     "sc": "Cutting zip-ties off new gear at the airport arrivals hall. Legally."
    },
    {
     "n": 8,
     "x": 58,
     "y": 81,
     "cat": "OPEN",
     "name": "Bottle · can · box openers",
     "desc": "Three openers plus a pry bar edge for daily abuse.",
     "sc": "Van-life dinner: can of beans, taped box, capped bottle. One card."
    },
    {
     "n": 9,
     "x": 12,
     "y": 14,
     "cat": "FIRE",
     "name": "Fire-starter scraper",
     "desc": "Hardened scraper edge that throws sparks off a ferro rod.",
     "sc": "Wet lighter at the campsite; scrape the ferro rod and the fire's going."
    }
   ]
  },
  {
   "id": "officeworker",
   "badge": "40-IN-1 · ZERO BLADES",
   "name": "OfficeWorker",
   "img": "https://mrf.tools/cdn/shop/files/Gemini_Generated_Image_fswjurfswjurfswj_7017dd76-252b-4c52-9845-6abc7a0769d9.png?v=1778008232&width=1200",
   "url": "/products/officeworker-40-in-1-blade-free-card-tool-flight-friendly-edc",
   "price": "from $29",
   "spec": "85 × 55 × 2 MM · BLADE-FREE BY DESIGN",
   "tools": [
    {
     "n": 1,
     "x": 36,
     "y": 10,
     "cat": "OFFICE",
     "name": "Staple & clip puller",
     "desc": "Hooked cutout that lifts staples and paper clips without tearing the page.",
     "sc": "Un-stapling a 40-page report to re-scan one sheet — without mangling it."
    },
    {
     "n": 2,
     "x": 67,
     "y": 47,
     "cat": "MEASURE",
     "name": "Protractor 0–180°",
     "desc": "Full half-circle protractor engraved along the card edge.",
     "sc": "Sketching a bracket angle in a meeting — measured, not eyeballed."
    },
    {
     "n": 3,
     "x": 20,
     "y": 13,
     "cat": "MEASURE",
     "name": "Circle template & compass hole",
     "desc": "Drilled radii plus a pivot hole to sweep clean arcs with any pen.",
     "sc": "Whiteboard diagrams with actual round circles. Colleagues notice."
    },
    {
     "n": 4,
     "x": 17,
     "y": 52,
     "cat": "MEASURE",
     "name": "Wire & drill gauge 3–8 mm",
     "desc": "Slot gauge that sizes drill bits, wire and bolts instantly.",
     "sc": "Which drill made this hole? Slide the card over the bit and read it off."
    },
    {
     "n": 5,
     "x": 10,
     "y": 39,
     "cat": "FIX",
     "name": "Hex wrench set",
     "desc": "Multiple hex cutouts for the fasteners hiding in office furniture and laptops stands.",
     "sc": "The wobbly conference chair everyone ignores — fixed in 30 seconds."
    },
    {
     "n": 6,
     "x": 50,
     "y": 80,
     "cat": "FIX",
     "name": "Phillips & flat screwdrivers",
     "desc": "Corner-machined driver tips for everyday screws.",
     "sc": "Swapping batteries in a wireless mouse — the flathead corner opens the hatch."
    },
    {
     "n": 7,
     "x": 44,
     "y": 30,
     "cat": "OPEN",
     "name": "Bottle & can opener",
     "desc": "Cap lifter and can edge, desk-friendly.",
     "sc": "Office party, no opener in the kitchen drawer. There never is."
    },
    {
     "n": 8,
     "x": 28,
     "y": 88,
     "cat": "OPEN",
     "name": "Box opener (blade-free)",
     "desc": "A scraping edge that cuts packing tape without an exposed blade.",
     "sc": "Daily Amazon boxes opened without a knife that makes colleagues nervous."
    },
    {
     "n": 9,
     "x": 86,
     "y": 30,
     "cat": "CUT",
     "name": "Thread & strap cutter",
     "desc": "Recessed slot that cuts string, zip-ties and loose threads safely.",
     "sc": "A loose thread on your jacket, two minutes before a client call."
    }
   ]
  },
  {
   "id": "designer",
   "badge": "DRAFTING · 5 COLOURS",
   "name": "Designer",
   "img": "https://mrf.tools/cdn/shop/files/mrf26-designer-map.png?v=b3",
   "url": "/products/designer",
   "price": "from $19.50",
   "spec": "85 × 54 MM · ANODISED ALUMINIUM",
   "tools": [
    {
     "n": 1,
     "x": 50,
     "y": 24,
     "cat": "MEASURE",
     "name": "Metric ruler, 0–80 mm",
     "desc": "Laser-etched millimetre scale along the top edge, readable to 1 mm with half-millimetre ticks.",
     "sc": "Measuring bolt-hole spacing on a drawing while the tape measure is two floors down."
    },
    {
     "n": 2,
     "x": 50,
     "y": 74,
     "cat": "MEASURE",
     "name": "Imperial ruler + PPI 350",
     "desc": "Inch scale on the bottom edge, plus a printing-industry PPI 350 reference strip.",
     "sc": "Checking a print bleed at the copy shop and converting to inches on the spot."
    },
    {
     "n": 3,
     "x": 23,
     "y": 45,
     "cat": "ANGLE",
     "name": "Protractor, 0–180°",
     "desc": "Full half-circle protractor with 1° ticks, numbered in both directions.",
     "sc": "Setting a 37° roof pitch on a sketch without hunting for a plastic triangle."
    },
    {
     "n": 4,
     "x": 50,
     "y": 40,
     "cat": "DRAW",
     "name": "Circle templates ø14–ø30",
     "desc": "The large template holes draw clean circles with a fineliner or a 0.5 mm pencil — no piercing compass point.",
     "sc": "Blocking out logo circles in a notebook at a client meeting."
    },
    {
     "n": 5,
     "x": 69,
     "y": 52,
     "cat": "DRAW",
     "name": "Small circles ø6 · ø10 · ø12",
     "desc": "The small-diameter set for bolt heads, hole callouts and bullets on a technical sketch.",
     "sc": "Marking drill positions on a shelf template before the hardware run."
    },
    {
     "n": 6,
     "x": 77,
     "y": 31,
     "cat": "ANGLE",
     "name": "Radian scale · Rad 57.3",
     "desc": "One radian marked at 57.3° for converting between degrees and radians on the card.",
     "sc": "Sanity-checking a CAD angle in radians during a call with the machinist."
    },
    {
     "n": 7,
     "x": 74,
     "y": 42,
     "cat": "DRAW",
     "name": "Isometric guide lines",
     "desc": "Radial guides fanning off the centre for fast isometric and axonometric construction lines.",
     "sc": "Sketching a 3D enclosure concept in isometric on the back of a napkin."
    },
    {
     "n": 8,
     "x": 18,
     "y": 33,
     "cat": "MEASURE",
     "name": "Conversion legend 1 cm = 0.394\"",
     "desc": "Etched conversion factor so metric and imperial drawings cross-read without a calculator.",
     "sc": "Reading a US-spec datasheet against a metric drawing."
    },
    {
     "n": 9,
     "x": 11,
     "y": 26,
     "cat": "DRAW",
     "name": "French curve corner",
     "desc": "The corner cutout and eyelet give a small radius to trace, plus a lanyard point for the studio wall.",
     "sc": "Rounding a corner on a packaging mock-up by tracing the cutout."
    }
   ]
  }
 ]
};